import { GraphQLUpcomingTicketsRequester } from '@cobliteam/api-lib';
import type { UpcomingTickets } from '@cobliteam/api-lib/src/__generated__/graphql';
import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import useAuthStore from '../../useSession/store/useAuthStore';

const QUERY_KEY = 'UPCOMING_TICKETS';

type UseUpcomingTicketsParams = {
  options?: Partial<UseQueryOptions<UpcomingTickets | null>>;
};

const requester = new GraphQLUpcomingTicketsRequester();

// A frota vai na key: depois de uma troca, o cache da frota anterior não é servido para a nova.
// Exportado para quem busca sob demanda (`queryClient.fetchQuery`) compartilhar o cache com o hook.
const upcomingTicketsQueryOptions = (fleetId: string | undefined) => ({
  queryKey: [QUERY_KEY, fleetId],
  queryFn: () => requester.getUpcomingTickets(),
});

const useUpcomingTickets = (params?: UseUpcomingTicketsParams) => {
  const fleetId = useAuthStore((s) => s.session?.fleet.id);

  return useQuery<UpcomingTickets | null>({
    ...params?.options,
    ...upcomingTicketsQueryOptions(fleetId),
    enabled: !!fleetId && (params?.options?.enabled ?? true),
  });
};

export { QUERY_KEY, upcomingTicketsQueryOptions, useUpcomingTickets };
export default useUpcomingTickets;
